import React from 'react';
import { Box, Flex, Link, Icon, HStack, Text, useColorModeValue, Heading } from '@chakra-ui/react';
import { FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';

const Footer = () => {
  return (
    <Box  bg={useColorModeValue('white', 'gray.800')}  py={20} id="contact">
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <Heading fontSize="lg">Contact Me</Heading>
        <Text fontSize="md" mt={10}>
          Contact Number  <Link href="tel:+918368373471">+91 8368373471</Link>
        </Text>
        <Text fontSize="md" mt={2}>
          Email Address -{' '}
          <Link href="mailto:dkp041297@gmail.com">dkp041297@gmail.com</Link>
        </Text>
        <Text fontSize="md" mt={2}>
          Address - Noida, Uttar Pradesh, Pincode - 201102
        </Text>
      </Flex>
      <HStack spacing={4} justifyContent="center" mt={4}>
        <Link href="mailto:dkp041297@gmail.com" isExternal>
          <Icon as={FaEnvelope} boxSize={6} />
        </Link>
        <Link href="https://www.linkedin.com/in/deepak-prajapati-offical/" isExternal>
          <Icon as={FaLinkedin} boxSize={6} />
        </Link>
        <Link href="https://github.com/Deepak1181" isExternal>
          <Icon as={FaGithub} boxSize={6} />
        </Link>
      </HStack>
    </Box>
  );
};

export default Footer;
